import React from 'react';

import TRANSLATIONS from './translations@default.json';

const PageCounter = ({ currentPageNum, pagesCount }) => (
	<li
		className="text-body-sm text-center text-tertiary w-full py-2"
		data-testid="pageCounter"
		data-page-number={currentPageNum}>
		{TRANSLATIONS.page} {currentPageNum} {TRANSLATIONS.of} {pagesCount}
	</li>
);

export default PageCounter;
